import { cn } from '@/utils/classUtils';
import { type ComponentProps } from 'react';
import { FlexCol } from './flex';
import { Text } from './text';

type TextareaProps = ComponentProps<'textarea'> & {
  label?: string;
  error?: string;
};

const Textarea = ({
  className,
  label,
  required,
  error,
  ...props
}: TextareaProps) => {
  return (
    <FlexCol gap="1" className="flex-grow">
      {(required || label) && (
        <label>
          {required && (
            <Text as="span" color="danger" className="mr-0.5">
              *
            </Text>
          )}
          {label && (
            <Text as="span" variant="body-sm">
              {label}
            </Text>
          )}
        </label>
      )}
      <textarea
        data-slot="textarea"
        required={required}
        className={cn(
          'flex min-h-0 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          error && 'border-red-500',
          className
        )}
        {...props}
      />
      {error && (
        <Text variant="body-xs" color="danger">
          {error}
        </Text>
      )}
    </FlexCol>
  );
};

export { Textarea };
